import React, { ChangeEvent, Dispatch, useEffect, useState } from 'react'
import { CloseIcon, SearchIcon } from '../iconSet/IconSet'

export type UserColumnDataType = {
    name: string;
    value: string;
}

export type UserRowTypes = {
    name: string;
    department: string;
    role:  string;
}

export type UserDataRowType = {
    id: string;
    data: UserRowTypes
}

type UserDataPickerType = {
    setCloseState: Dispatch<React.SetStateAction<boolean>>
    columnData: UserColumnDataType[];
    rowData: UserDataRowType[];
    columnDefinition?: string;
    handleRowClick?: (event: React.MouseEvent<HTMLDivElement>, item: UserDataRowType) => void
}

const UserDataPicker = (props: UserDataPickerType) => {

    const [rowData, setRowData] = useState<UserDataRowType[]>(props.rowData || [])
    const [columnData, setColumnData] = useState<UserColumnDataType[]>(props.columnData || [])

    const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
        const text = event.target.value;
        
        if (text === "")
        {
            setRowData(props.rowData)
        }
        else 
        {
            setRowData(prevState => {
                return rowData.filter(item => 
                    item.data.name.toLowerCase().includes(text.toLowerCase()) ||
                    item.data.department.toLowerCase().includes(text.toLowerCase()) ||
                    item.data.role.toLowerCase().includes(text.toLowerCase())
                )
            })
        }
    }

    useEffect(() => {
        setRowData(props.rowData)
    }, [props.rowData])

    // useEffect(() => {
    //     console.log("DATA 1 -> ", props.columnData)
    //     console.log("DATA 2 -> ", props.rowData)
    //     console.log("______________________________")
    // }, [])

    return (
        <div className='data-picker'>
            <div className='data-wrapper' style={{ width: '40rem'}}>
                <div className='header'>
                    <div className='search-wrapper'>
                        <input type="text" placeholder="Search users here" onChange={(e) => handleSearch(e)}/>
                        <div>
                            <SearchIcon width="1.3rem" color="var(--color-text)"/>
                        </div>
                    </div>
                    <div className="close-button" onClick={(e) => props.setCloseState(false)}>
                        <CloseIcon width="1.5rem" color="var(--color-text"/>
                    </div>
                </div>
                <div className="body-wrapper">
                    {columnData.length > 0 && rowData.length > 0 && Object.keys(rowData[0].data).length > 0 && (columnData.length === Object.keys(rowData[0].data).length) ? (
                        <>
                            <div className="column" style={{gridTemplateColumns: props.columnDefinition ? props.columnDefinition : `repeat(${columnData.length}, 1fr)`}}>
                                {columnData.map((item, index) => (
                                    <span key={index}>{item.name}</span>
                                ))}
                            </div>
                           
                            <div className="table-row-wrapper">
                                {rowData.map((item, index) => (
                                    <div className="row" key={index} style={{gridTemplateColumns: props.columnDefinition ? props.columnDefinition : `repeat(${columnData.length}, 1fr)`}} onClick={(e) => props.handleRowClick?.(e, item)}>
                                        {Object.entries(item.data).map(([key, value]) => (
                                            <span key={key}>{value}</span>
                                        ))}
                                    </div>
                                ))}
                            </div>
                            
                        </>
                    ) : (
                        <div className="no-data-wrapper">No any data available</div>
                    )}
                    
                </div>
            </div>
        </div>
    )
}

export default UserDataPicker